import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AdminPanel = () => {
  const [cars, setCars] = useState([]);

  useEffect(() => {
    const fetchCars = async () => {
      const response = await axios.get('http://localhost:8000/api/cars/', {
        headers: { Authorization: `Bearer YOUR_ADMIN_TOKEN` },
      });
      setCars(response.data);
    };
    fetchCars();
  }, []);

  return (
    <div>
      <h1>Админ-панель</h1>
      <h2>Автомобили</h2>
      <ul>
        {cars.map((car) => (
          <li key={car.id}>{car.brand} {car.model}</li>
        ))}
      </ul>
    </div>
  );
};

export default AdminPanel;
